import React from "react";
import { AspectRatio, Box, Flex } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import { Section } from "components/section";
import { TextTitle } from "ui/text";
import bgImage from "../../../../../public/assets/platform/ai-decisioning/blurred-bg.png";
import { EmailOffer } from "./email-offer";
import { EmailOfferMobile } from "./email-offer-mobile";

const dropShadowMd =
  "drop-shadow(0px 34.807px 20.627px rgba(0, 0, 0, 0.02)) drop-shadow(0px 15.47px 15.47px rgba(0, 0, 0, 0.04)) drop-shadow(0px 3.867px 7.735px rgba(0, 0, 0, 0.05))";

export function AidAgents() {
  return (
    <Section id="ai-agents" bg="new.violet.950" themeBgColor="new.violet.950" theme="dark">
      <Flex
        borderRadius={{ base: "small", md: "bigger" }}
        direction="column"
        pt={{ base: "biggest", md: "huge" }}
        pb="0"
        pl={{ base: "small", md: "biggest" }}
        pr={{ base: "0", sm: "big", md: "biggest" }}
        pos="relative"
        overflow="hidden"
      >
        <Box pos="absolute" inset={0}>
          <Box boxSize="100%" pos="relative">
            <DecorativeBackgroundImage src={bgImage} placeholder="blur" />
          </Box>
        </Box>

        <Box pos="relative" zIndex={1}>
          <TextTitle
            pr={{ base: "small", sm: "0" }}
            titleAs="h2"
            align="center"
            size="lg"
            maxW="760px"
            theme="dark"
            title="AI agents put real personalization within reach"
            description="Deliver the right message, offer, channel, and timing for every customer, automatically. You provide the content and guardrails and AI agents optimize towards your campaign goals."
          />

          <Box mt={{ base: "bigger", xl: "biggest" }} filter={dropShadowMd}>
            <AspectRatio
              display={{ base: "none", sm: "block" }}
              ratio={1144 / 580}
              w="100%"
              mx="auto"
              pos="relative"
              overflow="hidden"
            >
              <EmailOffer />
            </AspectRatio>

            <AspectRatio
              display={{ base: "block", sm: "none" }}
              ratio={350 / 333}
              w="100%"
              maxW="500px"
              ml="auto"
              pos="relative"
            >
              <EmailOfferMobile />
            </AspectRatio>
          </Box>
        </Box>
      </Flex>
    </Section>
  );
}
